export const FINANCIAL_TARGET_ROW_IDS = {
    TOTAL: "total",
    TARGET: "target",
    VARIANCE: "variance",
    VARIANCE_PERCENTAGE: "variancePercentage",
} as const;
